import { call, put, all, fork, takeEvery } from 'redux-saga/effects'

import { showLoading, hideLoading } from 'react-redux-loading-bar'

import CustomersService from '../middlewares/customers'
import { syncCustomerBookletCoupons as syncCustomerBookletCouponsApi } from '../../api/customers'

import {
  GET_CUSTOMERS_REQUEST,
  GET_CUSTOMERS,
  GET_CUSTOMER_REQUEST,
  GET_CUSTOMER,
  GET_CUSTOMERS_REQUEST_PENDING,
  GET_CUSTOMERS_REQUEST_SUCCESS,
  GET_CUSTOMERS_REQUEST_ERROR,
  CHANGE_CUSTOMERS_REQUEST_PENDING,
  CHANGE_CUSTOMERS_REQUEST_SUCCESS,
  CHANGE_CUSTOMERS_REQUEST_ERROR,
  SYNC_CUSTOMER_SAP_REQUEST,
  SYNC_CUSTOMER_BOOKLET_COUPONS_REQUEST,
  UPDATE_CUSTOMER_REQUEST,
} from '../types/customers'

function* getCustomersWatcher() {
  yield takeEvery(GET_CUSTOMERS_REQUEST, getCustomersWorker)
}

function* getCustomerWatcher() {
  yield takeEvery(GET_CUSTOMER_REQUEST, getCustomerWorker)
}

function* syncCustomerSapWatcher() {
  yield takeEvery(SYNC_CUSTOMER_SAP_REQUEST, syncCustomerSapWorker)
}

function* updateCustomerWatcher() {
  yield takeEvery(UPDATE_CUSTOMER_REQUEST, updateCustomerWorker)
}

function* syncCustomerBookletCouponsWatcher() {
  yield takeEvery(SYNC_CUSTOMER_BOOKLET_COUPONS_REQUEST, syncCustomerBookletCouponsWorker)
}

function* getCustomersWorker({ payload: { currentPage, pageSize, sortType, sortOrder, search } }) {
  try {
    yield put(showLoading())
    yield put({ type: GET_CUSTOMERS_REQUEST_PENDING })
    const response = yield call(
      CustomersService.getCustomers,
      currentPage,
      pageSize,
      sortType,
      sortOrder,
      search,
    )
    const { result, total } = response.data.data
    yield put({
      type: GET_CUSTOMERS,
      payload: {
        items: result,
        pagination: {
          current: currentPage,
          pageSize: pageSize,
          total: total,
        },
      },
    })
    yield put({ type: GET_CUSTOMERS_REQUEST_SUCCESS })
    yield put(hideLoading())
  } catch (error) {
    yield put({ type: GET_CUSTOMERS_REQUEST_ERROR, payload: error.response.data.messages })
    yield put(hideLoading())
  }
}

function* getCustomerWorker({ payload: { id } }) {
  try {
    yield put(showLoading())
    yield put({ type: GET_CUSTOMERS_REQUEST_PENDING })
    const response = yield call(CustomersService.getCustomerById, id)
    const customer = response.data.data
    yield put({ type: GET_CUSTOMER, payload: customer })
    yield put({ type: GET_CUSTOMERS_REQUEST_SUCCESS })
    yield put(hideLoading())
  } catch (error) {
    yield put({ type: GET_CUSTOMERS_REQUEST_ERROR, payload: error.response.data.messages })
    yield put(hideLoading())
  }
}

function* syncCustomerSapWorker({ payload: { id } }) {
  try {
    yield put(showLoading())
    yield put({ type: CHANGE_CUSTOMERS_REQUEST_PENDING })
    // call SAP sync endpoint
    yield call(CustomersService.syncCustomerSapCode, id)
    // refresh customer data
    const response = yield call(CustomersService.getCustomerById, id)
    const customer = response.data.data
    yield put({ type: GET_CUSTOMER, payload: customer })
    yield put({ type: CHANGE_CUSTOMERS_REQUEST_SUCCESS })
    yield put(hideLoading())
  } catch (error) {
    yield put({
      type: CHANGE_CUSTOMERS_REQUEST_ERROR,
      payload: error.response?.data?.messages || [error.message],
    })
    yield put(hideLoading())
  }
}

function* updateCustomerWorker({ payload }) {
  const { id, data, onSuccess, onError } = payload || {}
  try {
    yield put(showLoading())
    yield put({ type: CHANGE_CUSTOMERS_REQUEST_PENDING })

    const body = {
      phoneNumber: data?.mobile?.replace(/\s+/g, '') || undefined,
    }

    yield call(CustomersService.updateCustomer, id, body)

    const refreshedResponse = yield call(CustomersService.getCustomerById, id)
    const updated = refreshedResponse.data.data

    yield put({ type: GET_CUSTOMER, payload: updated })
    yield put({ type: CHANGE_CUSTOMERS_REQUEST_SUCCESS })

    if (typeof onSuccess === 'function') {
      yield call(onSuccess, updated)
    }
  } catch (error) {
    const messages = error.response?.data?.messages || [error.message]
    yield put({
      type: CHANGE_CUSTOMERS_REQUEST_ERROR,
      payload: messages,
    })
    if (typeof onError === 'function') {
      yield call(onError, messages)
    }
  } finally {
    yield put(hideLoading())
  }
}

function* syncCustomerBookletCouponsWorker({ payload }) {
  const { id, onSuccess, onError } = payload || {}
  try {
    yield put(showLoading())
    yield put({ type: CHANGE_CUSTOMERS_REQUEST_PENDING })

    const result = yield call(syncCustomerBookletCouponsApi, id)

    const refreshedResponse = yield call(CustomersService.getCustomerById, id)
    const customer = refreshedResponse.data.data

    yield put({ type: GET_CUSTOMER, payload: customer })
    yield put({ type: CHANGE_CUSTOMERS_REQUEST_SUCCESS })

    if (typeof onSuccess === 'function') {
      yield call(onSuccess, result)
    }
  } catch (error) {
    const messages = error.response?.data?.messages || [error.message]
    yield put({
      type: CHANGE_CUSTOMERS_REQUEST_ERROR,
      payload: messages,
    })
    if (typeof onError === 'function') {
      yield call(onError, messages, error)
    }
  } finally {
    yield put(hideLoading())
  }
}

export default function* customers() {
  yield all([
    fork(getCustomersWatcher),
    fork(getCustomerWatcher),
    fork(syncCustomerSapWatcher),
    fork(updateCustomerWatcher),
    fork(syncCustomerBookletCouponsWatcher),
  ])
}
